import React from 'react';
import { NavLink } from 'react-router-dom';
import cl from './Cart.module.css';
import { getRandomNumber } from '../Home/Home';

const Cart = (props) => {
  const { cartItems, onAdd, onRemove } = props;
  const subTotalPrice = cartItems.reduce((a, c) => a + c.oldPrice * c.qty, 0);
  const totalPrice = cartItems.reduce(
    (a, c) => a + ((c.oldPrice * (100 - c.discount)) / 100) * c.qty,
    0
  );
  const discountPrice = subTotalPrice - totalPrice;
  return (
    <section className={cl.main_cart}>
      <h2 className={cl.header}>Cart Items</h2>
      <div>
        {cartItems.length === 0 && (
          <div className={cl.header_empty}>Cart Is Empty</div>
        )}
        {cartItems.map((item) => (
          <div key={getRandomNumber(1, 10000)} className={cl.row}>
            <div className={cl.row_img_container}>
              <img src={item.images ? item.images[0] : ""} alt="" />
            </div>
            <div className={cl.name}>{item.name}</div>
            <div className={cl.buttons}>
              <button onClick={() => onAdd(item)} className={cl.add}>
                +
              </button>
              <button onClick={() => onRemove(item)} className={cl.remove}>
                -
              </button>
            </div>
            <div className={cl.amount}>
              {item.qty} x $
              {((item.oldPrice * (100 - item.discount)) / 100).toFixed(2)}
            </div>
          </div>
        ))}
      </div>
      {cartItems.length !== 0 && (
        <>
          <hr></hr>
          <div>
            <div className={cl.price}>
              <div>Subtotal</div>
              <div>${subTotalPrice.toFixed(2)}</div>
            </div>
            <div className={cl.price}>
              <div>Discount</div>
              <div>-${discountPrice.toFixed(2)}</div>
            </div>
            <div className={cl.price_total}>
              <div>Total Price</div>
              <div>${totalPrice.toFixed(2)}</div>
            </div>
          </div>
          <NavLink className={cl.button_checkout} to="/checkout">
            CHECK OUT
          </NavLink>
        </>
      )}
    </section>
  );
};

export default Cart;
